import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../services/api';
import { decodeFuelType, formatPrice } from '../constants/carFilters';

// Glavni zaslon PWA — replika Android MainScreen:
// stats + gumbi (Moj filter / Test obvestilo / SMS plosca) + seznam vseh nedavnih avtov.
export default function EndUserCars() {
  const navigate = useNavigate();
  const [cars, setCars] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [testMsg, setTestMsg] = useState('');

  useEffect(() => {
    let alive = true;
    const load = () => {
      apiService.getRecentCars(24)
        .then((r) => { if (alive) setCars(Array.isArray(r.data) ? r.data : []); })
        .catch(() => {})
        .finally(() => { if (alive) setLoading(false); });
      apiService.getCarStats().then((r) => { if (alive) setStats(r.data); }).catch(() => {});
    };
    load();
    const iv = setInterval(load, 15000);
    return () => { alive = false; clearInterval(iv); };
  }, []);

  const sendTest = async () => {
    setTestMsg('Pošiljam…');
    try {
      const { data } = await apiService.testWebPush();
      setTestMsg(data.sent > 0 ? `Poslano ✓ (${data.sent})` : 'Najprej vklopi obvestila (Moj filter).');
    } catch (e) {
      setTestMsg('Napaka pri pošiljanju testa.');
    }
    setTimeout(() => setTestMsg(''), 5000);
  };

  return (
    <>
      <div style={{ ...box, padding: 16, marginBottom: 14 }}>
        <span style={{ color: '#555', fontSize: 15 }}>Avtomobilov v zadnjih 24 urah: </span>
        <b style={{ fontSize: 15, color: '#222' }}>{stats && stats.last24h != null ? stats.last24h : '…'}</b>
      </div>

      <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
        <button onClick={() => navigate('/app/filter')} style={{ ...actionBtn, background: '#007AFF' }}>🔍 Moj filter</button>
        <button onClick={sendTest} style={{ ...actionBtn, background: '#34C759' }}>🔔 Test obvestilo</button>
      </div>
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
        <button onClick={() => navigate('/app/sms')} style={{ ...actionBtn, background: '#5856D6' }}>💬 SMS plošča</button>
        <button onClick={() => navigate('/app/v-okvari')} style={{ ...actionBtn, background: '#FF3B30' }}>🔧 V okvari</button>
        <button onClick={() => navigate('/app/prvi-lastnik')} style={{ ...actionBtn, background: '#198754' }}>🥇 1. lastnik</button>
      </div>
      {testMsg ? <div style={{ fontSize: 13, color: '#555', margin: '10px 2px 0' }}>{testMsg}</div> : null}

      <div style={{ fontSize: 20, fontWeight: 700, color: '#222', margin: '20px 2px 12px' }}>
        Avtomobili (zadnjih 24h)
      </div>

      {loading ? (
        <div style={{ ...box, padding: 16, color: '#666' }}>Nalagam…</div>
      ) : cars.length === 0 ? (
        <div style={{ ...box, padding: 20, textAlign: 'center' }}>
          <div style={{ color: '#666' }}>Ni avtomobilov v zadnjih 24 urah</div>
        </div>
      ) : (
        cars.map((c) => <CarCard key={c.id} c={c} />)
      )}
    </>
  );
}

const box = { background: '#fff', borderRadius: 12, boxShadow: '0 1px 4px rgba(0,0,0,0.07)', border: '1px solid #eee' };
const actionBtn = {
  flex: 1, color: '#fff', border: 'none', borderRadius: 10,
  padding: '15px 12px', fontSize: 15, fontWeight: 700, cursor: 'pointer',
};
const detailStyle = { fontSize: 14, color: '#666', marginBottom: 5 };

function CarCard({ c }) {
  const title = `${c.znamka || ''} ${c.model || ''}`.trim() || 'Neznano vozilo';
  const d = c.scrapedAt ? new Date(c.scrapedAt) : null;
  const dateStr = d && !isNaN(d.getTime())
    ? `${d.toLocaleDateString('sl-SI')} ${d.toLocaleTimeString('sl-SI', { hour: '2-digit', minute: '2-digit' })}`
    : '';
  const href = c.avtonetId ? `https://www.avto.net/Ads/details.asp?id=${c.avtonetId}` : undefined;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      style={{ ...box, display: 'block', textDecoration: 'none', color: '#222', padding: 16, marginBottom: 12 }}
    >
      <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>{title}</div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 10, marginBottom: 10 }}>
        <span style={{ fontSize: 18, fontWeight: 700, color: '#007AFF' }}>{formatPrice(c.cena)}</span>
        <span style={{ fontSize: 13, color: '#888', whiteSpace: 'nowrap' }}>{dateStr}</span>
      </div>
      {c.letnik ? <div style={detailStyle}>📅 Letnik: {c.letnik}</div> : null}
      {c.mileage ? <div style={detailStyle}>🛣️ {c.mileage}</div> : null}
      {c.gorivo ? <div style={detailStyle}>⛽ {decodeFuelType(c.gorivo)}</div> : null}
    </a>
  );
}
